import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-background py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-190" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-191" data-mp="j76t2jrmpvor">
        <SectionHeading id="summary-title" data-id="element-192" data-mp="j8hw2hd92zet">Everything Included:</SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-primary/40 bg-surface shadow-glow sm:grid-cols-2" data-id="element-193" data-mp="1gv74b8yjq894">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-primary/20 p-4 sm:odd:border-r" data-id="element-194" data-mp="1btrmrqvkujvh">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary" data-id="element-195" data-mp="12v631sedcyt4">
                <CheckIcon className="h-3.5 w-3.5 text-background" aria-hidden="true" data-id="element-196" data-mp="3rni2bl9ez38z" />
              </span>
              <b className="text-sm text-foreground" data-id="element-197" data-mp="3nkvfjyrlo8in">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}